import React from 'react'
import { Navigate } from 'react-router-dom'
import AdminLayout from '../admin-layout'
import { useAuth } from '@src/hooks/useAuth'

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth()
  if (!isAuthenticated) {
    return <Navigate to="/login" />
  }
  return <>{children}</>
}

const Root: React.FC = () => {
  return (
    <ProtectedRoute>
      <AdminLayout />
    </ProtectedRoute>
  )
}

export default Root
